import React from 'react';
import { Container, Loader, Feed } from 'semantic-ui-react';
import Emoji from 'react-emoji-render';

import { connect } from 'react-redux';
import { fetchTeam, clearTeam, fetchTeamActivity } from '../actions/teams';

import DateLocalizer from '../utils/DateLocalizer';

class TeamActivity extends React.Component {
  componentWillMount() {
    this.props.fetchTeam(this.teamId);
    this.props.fetchTeamActivity(this.teamId, {});
  }

  componentWillUnmount() {
    this.props.clearTeam();
  }

  get teamId() {
    return this.props.match.params.teamId;
  }

  render() {
    const { activity } = this.props;

    return (
      <Container>
        <Loader active={!activity} />
        {activity && activity.length > 0 && (
          <Feed>
            {activity.map(event => (
              <Feed.Event
                key={event.id}
                image={event.user.avatar_url}
                date={new DateLocalizer(event.created_at).toDateTime()}
                summary={
                  <div className="summary">
                    <Emoji text={event.summary} />
                  </div>
                }
                extraText={<em>{event.reason}</em>}
              />
            ))}
          </Feed>
        )}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  team: state.teams.team,
  activity: state.teams.activity
});

const mapDispatchToProps = dispatch => ({
  fetchTeam: teamId => {
    dispatch(fetchTeam(teamId));
  },
  clearTeam: () => {
    dispatch(clearTeam());
  },
  fetchTeamActivity: teamId => {
    dispatch(fetchTeamActivity(teamId, {}));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamActivity);



// WEBPACK FOOTER //
// ./src/containers/TeamActivity.js